import { useEffect, useState, useRef } from 'react';
import { useAuth } from '../../utils/AuthContext';

const useBooleanState = (initialValue) => {
  const [value, setValue] = useState(initialValue === true);
  const setTrue = () => setValue(true);
  const setFalse = () => setValue(false);
  const toggle = () => setValue(!value);

  return { value, setTrue, setFalse, toggle };
};

const useVersion = () => {
  const [version, setVersion] = useState(new Date());
  const incrementVersion = () => setVersion(new Date());

  return [version, incrementVersion];
};

const useAsync = (asyncFunction) => {
  const [value, setValue] = useState();
  const functionRef = useRef(asyncFunction);
  functionRef.current = asyncFunction;

  useEffect(() => {
    const load = async () => setValue(await functionRef.current());
    load();
  }, []);

  return value;
};

const useRefreshingAsync = (asyncFunction) => {
  const { dataVersion } = useAuth();
  const [value, setValue] = useState();
  const functionRef = useRef(asyncFunction);
  functionRef.current = asyncFunction;

  useEffect(() => {
    const load = async () => setValue(await functionRef.current());
    load();
  }, [dataVersion]);

  return value;
};

export { useBooleanState, useVersion, useAsync, useRefreshingAsync };
